import { DutyTimeState } from './reducers';

const getDutyScheduleModalState = ({ pages: { dutyTimeModal } }) => dutyTimeModal as DutyTimeState;

export const getDutyTimeModalMode = state => getDutyScheduleModalState(state).modalMode;
